<template>
  <div v-loading="imgloading" class="img">
    <div class="select-img" v-if="!isRadio">选择图片</div>
    <div class="drop-out" @click="out">
      <img alt="" :src="g_imgSrc.delete" class="out" @click="out" />
    </div>
    <template v-if="!isRadio">
      <div style="overflow: hidden">
        <tagSelect v-if="type === 'public'" class="tag-select" @emitAddPublic="emitAddPublic" />
        <tagSelectAgent v-if="type === 'app'" class="tag-select" @emitAddPublic="emitAddPublic" />
        <div class="img-updata">
          <el-button @click="uploadImg">上传图片</el-button>
        </div>
      </div>
    </template>

    <imgcheckbox
      v-if="!isRadio"
      :type="type"
      :list="datalist"
      @checkedChange="checkedChange"
      :forbidden="forbidden"
    />
    <imgRadiobox
      v-else
      :type="type"
      :list="datalist"
      @checkedChange="checkedChange"
      :forbidden="forbidden"
    ></imgRadiobox>

    <div v-if="datalist.length === 0" class="noDatalist">
      <img alt="" :src="g_imgSrc.bgWhite" class="noDatalist-img" />
      <div class="release-list-noData-word">暂无相关内容</div>
    </div>
    <el-pagination
      v-if="datalist.length > 0"
      class="pagination"
      style="background-color: #ffffff"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      :current-page.sync="setCurrentPage"
      @current-change="handleCurrentChange"
    />
    <div slot="footer" class="dialog-footer" v-if="datalist.length > 0">
      <el-button class="closeCancel" @click="out">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>
<script>
import imgcheckbox from './imgCheckbox';
import imgRadiobox from './imgRadiobox';
import { EyaoSaaSSelectMaterialApi } from '@/api/releaseManagement';
import tagSelect from '@/components/tagSelect';
import tagSelectAgent from '@/components/tagSelectAgent';
import { arrUnique } from '@/utils/util';
export default {
  components: { tagSelect, imgcheckbox, imgRadiobox, tagSelectAgent },
  props: {
    type: {
      type: String,
      default: 'public',
    },
    imgclose: {
      type: Function,
      default: null,
    },
    imgIdList: {
      default: [],
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      total: 1, // 总条数
      size: 18, // 每页数量
      currentPage: 1, // 页数
      imgloading: false, // loading
      datalist: [], // 获取图片数组
      sortList: [], // 勾选为true的数组
      forbidden: false,
      Imglist: '', // 图片列表
      file_type: 1,
      publicIds: [],
      agentIds: [],
      setCurrentPage: 1,
    };
  },
  mounted() {
    this.getTaleData();
  },
  methods: {
    emitAddPublic(list) {
      if (this.type === 'public') {
        this.publicIds = list.map((item) => item.value);
      } else if (this.type === 'app') {
        this.agentIds = list.map((item) => item.value);
      }
      this.getTaleData(1);
    },
    // 勾选图片
    checkedChange(value) {
      // 去重
      this.sortList = arrUnique(value, 'mate_id');

      const maxlength = this.imgIdList.length + this.sortList.length;
      if (maxlength > 100) {
        this.forbidden = true;
        this.$message.error('最多可以选择100张图片');
        return;
      }
      this.forbidden = false;
    },
    // 查询素材库列表
    async getTaleData(
      page,
      query = {
        page: this.currentPage,
        limit: this.size,
        file_type: this.file_type,
        public_ids: this.publicIds,
      },
    ) {
      this.imgloading = true;
      if (page) {
        query.page = page;
        this.setCurrentPage = page;
      }
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      const res = await EyaoSaaSSelectMaterialApi({
        page_index: query.page,
        page_size: query.limit,
        mate_type: query.file_type, // 图片（image）、语音（voice）、视频（video）
        appids: this.publicIds,
        agent_ids: this.agentIds,
        mode,
      });
      for (let i = 0; i < res.mate_list.length; i++) {
        const e = res.mate_list[i];
        e.select = false;
        e.cos_file_url = window.cos_url + e.cos_url;
        e.operator_name = e.title;
      }
      this.datalist = res.mate_list;
      this.total = res.total;
      if (this.sortList.length > 0) {
        this.datalist.map((item) => {
          this.sortList.forEach((sortItem) => {
            if (sortItem.mate_id === item.mate_id) {
              item.select = true;
            }
          });
          return item;
        });
      }
      this.imgloading = false;
    },
    // 上传图片
    async uploadImg() {
      this.g_tourl(`/saas/materialManagement/material-img-upload.html`, {
        open: true,
      });
    },
    // 确定上传
    confirm() {
      this.imgclose();
      this.$emit('imgDatalist', this.sortList);
    },
    // 页面改变事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTaleData();
    },
    out() {
      this.sortList = [];
      this.imgclose();
    },
  },
};
</script>
<style scoped lang="scss">
.img {
  .tag-select {
    width: 80%;
    float: left;
    margin: 22px 0 0 20px;
  }
  .select-img {
    font-size: 16px;
    margin-left: 24px;
  }
  .drop-out {
    height: 18px;
    width: 20px;
    position: absolute;
    top: 30px;
    right: 44px;
    cursor: pointer;
    .out {
      width: 100%;
      cursor: pointer;
    }
  }
  .img-material {
    margin-top: 25px;
    width: 796px;
    height: 40px;
    border-bottom: 1px solid #e0e1e2;
    font-size: 16px;
    margin-left: 24px;
    color: #2f96ff;
  }
  .img-updata {
    width: 99px;
    height: 40px;
    margin: 34px 20px 0 0;
    font-size: 19px;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    float: right;
  }
  .noDatalist {
    width: 100%;
    text-align: center;
    .noDatalist-img {
      width: 240px;
      height: 192px;
      margin-top: 10vh;
    }
  }
  .dialog-footer {
    text-align: center;
    margin-top: 20px;
    .closeCancel {
      border: 1px solid #dcdfe6;
      background: #ffffff;
      color: #606266;
    }
    .closeCancel:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #606266;
    }
  }
  .dialog-footer ::v-deep .el-button span {
    font-weight: normal;
  }
  .pagination {
    text-align: right;
    margin: 0 20px 0 0;
  }
  .pagination ::v-deep .el-pager li.number {
    color: #606266;
  }
  .pagination ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }
  .pagination ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
  .el-dialog__header {
    padding: 0px;
  }
}
.el-button--primary:hover {
  background: #63b0ff;
  color: #ffffff;
}
</style>
